module.exports = __webpack_public_path__ + "img/wififastspot_ss_home.34dc1288.png";